/* eslint-disable */
export default {
    cp_menu_company_settings: "Organisation settings",
    cp_menu_participants: "Participants",
    cp_menu_finance: "Finance",
    cp_menu_users: "Users",
    cp_menu_builder: "Builder",
    cp_menu_ltp_settings: "LTP Settings",
    cp_menu_talent_analytics: "Talent analytics",
    cp_menu_example_reports: "Example reports"
};
